import Vue from 'vue'
import VueRouter from 'vue-router'
import Layout from '../views/Layout'
import Login from '../views/Login'
import local from "@/utils/local"

Vue.use(VueRouter)
// 解决警告
const routerPush = VueRouter.prototype.push
VueRouter.prototype.push = function push(location) {
  return routerPush.call(this, location).catch(error => error)
}
const routes = [
  // 登录
  {
    path: '/login',
    component: Login, 
  },
  {
    path:'/',
    component:Layout,
    redirect: '/user',
    meta:{title:"用户管理"},
    children:[
      { name:'用户管理',path:"/user",component:()=>import("@/views/User/userList.vue")}
    ]
  },

  //角色管理
  {
    path: '/role-Management',
    component: Layout,
    meta: { title: "角色管理" },
   
    children: [
      {  name:'角色管理',path: "", component: () => import("@/views/RoleManagement/roleManagement.vue") }
    ]
  },
  //账号管理
  {
    path: '/account',
    component: Layout,
    meta: { title: "账号管理" },

    children: [
      {name:'账号管理', path: "", component: () => import("@/views/Account/account.vue") },
      {name:'修改密码', path: "/acc-pwd", component: () => import("@/views/Account/accEdite.vue") }
    ]
  },
    //标签管理
    {
      path: '/label',
      component: Layout,
      meta: { title: "标签管理" },
     
      children: [
        {  name:'标签管理',path: "", component: () => import("@/views/Label/label.vue") }
      ]
    },


    //系统设置
    {
      path: '/sys',
      component: Layout,
      meta: { title: "系统设置" },
     
      children: [
        {  name:'系统设置',path: "", component: () => import("@/views/Sys/sys.vue") }
      ]
    },

   //酒吧审核
   {
    path: '/barExamine',
    component: Layout,
    meta: { title: "酒吧审核列表" },
   
    children: [
      {  name:'酒吧审核列表',path: "", component: () => import("@/views/BarList/barExamine.vue") },
      { name:'酒吧详情',path: "/barDetail", component: () => import("@/views/BarList/barDetail.vue") },

    ]
  },

  //酒吧管理
  {
    path: '/barList',
    component: Layout,
    meta: { title: "酒吧管理" },
    
    children: [
      { name:'酒吧列表',path: "", component: () => import("@/views/BarList/barList.vue") },
      { name:'新增酒吧',path: "/addBar", component: () => import("@/views/BarList/addBar.vue") },
      { name:'编辑酒吧',path: "/editBar", component: () => import("@/views/BarList/editBar.vue") },
      { name:'活动列表',path: "/activityList", component: () => import("@/views/BarList/activity.vue") },
      { name:'新增活动',path: "/addActivity", component: () => import("@/views/BarList/addActivity.vue") },
      { name:'活动编辑',path: "/activityEdit", component: () => import("@/views/BarList/activityEdit.vue") },
      { name:'icon列表',path: "/iconList", component: () => import("@/views/BarList/iconList.vue") },
  
    ]
  },

   //活动管理
   {
    path: '/activity',
    component: Layout,
    meta: { title: "活动管理" },
    
    children: [
      { name:'活动列表',path: "", component: () => import("@/views/Activity/activity.vue") },
      { name:'活动编辑',path: "/allActivityEdit", component: () => import("@/views/Activity/activityEdit.vue") },
      { name:'平台活动',path: "/platformActivity", component: () => import("@/views/Activity/platformActivity.vue") },
      { name:'兑换列表',path: "/platformActivityList", component: () => import("@/views/Activity/platformActivityList.vue") },
      { name:'公司活动',path: "/companyActivity", component: () => import("@/views/Activity/companyActivity.vue") },
      { name:'兑换码列表',path: "/codeList", component: () => import("@/views/Activity/codeList.vue") },

    ]
  },

   //酒吧评论审核
   {
    path: '/clockManage',
    component: Layout,
    meta: { title: "酒吧评论审核列表" },
    
    children: [
      { name:'酒吧评论审核列表',path: "", component: () => import("@/views/Comment/commentList.vue") },
      { name:'酒吧评论审核详情',path: "/commentDetail", component: () => import("@/views/Comment/commentDetail.vue") },
    ]
  },
  //会员管理
  {
    path: '/vip',
    component: Layout,
    meta: { title: "会员管理" },
    
    children: [
      {name:'会员管理', path: "", component: () => import("@/views/Vip/vip.vue") },
    ]
  },

    //Banner管理
    {
      path: '/banner',
      component: Layout,
      meta: { title: "轮播图管理" },
     
      children: [
        {  name:'轮播图管理',path: "", component: () => import("@/views/Banner/bannerList.vue") },
        {  name:'轮播图详情',path: "/bannerDetail", component: () => import("@/views/Banner/bannerDetail.vue") },
        {  name:'轮播图添加',path: "/addBanner", component: () => import("@/views/Banner/addBanner.vue") }
      ]
    },

     //意见反馈
     {
      path: '/feedback',
      component: Layout,
      meta: { title: "意见反馈" },
     
      children: [
        {  name:'意见反馈',path: "", component: () => import("@/views/Complaint/complaintList.vue") },
      ]
    },
      //订阅管理
      {
        path: '/subscription',
        component: Layout,
        meta: { title: "订阅管理" },
       
        children: [
          {  name:'订阅管理',path: "", component: () => import("@/views/subscription/index.vue") },
          {  name:'模板管理',path: "/template", component: () => import("@/views/subscription/template.vue") },
          {  name:'推送列表',path: "/pushList", component: () => import("@/views/subscription/pushList.vue") },
        ]
      },

    //404
    {
      path: '/404',
      component:  () => import("@/views/404.vue"),
    },
      //404
      {
        path: '*',
        redirect: '/404',
      },

]


const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})
// 路由守卫【保安】
router.beforeEach((to, from, next) => {
  let isLogin = local.get('t_k') ? true : false; // 获取登录的状态
  // 如果登录过 且是登录成功的
  if (isLogin) {
    next()  // 直接放行
  } else {
    // 否则
    // 如果去的是登录页
    if (to.path === '/login') {
      next() // 直接放行
    } else {
      next('/login') // 如果去的是别的页面 直接跳转到登录页
    }
  }
  })
export default router
